import { c as _c } from "react/compiler-runtime";
import { Avatar, AvatarFallback, AvatarImage } from '@achra/ui/avatar';
import { cn } from '@achra/ui/lib/utils';
import * as React from 'react';
import { TwoUserIcon } from './two-user-icon';
export interface CircleAvatarWithIconProps extends React.ComponentProps<typeof Avatar> {
  icon: boolean;
  image?: string | null;
  fallbackText: string;
  isCoreUnit?: boolean;
}
function AvatarWithIcon(t0) {
  const $ = _c(25);
  let avatarProps;
  let className;
  let fallbackText;
  let icon;
  let image;
  let t1;
  if ($[0] !== t0) {
    ({
      image,
      fallbackText,
      className,
      icon,
      isCoreUnit: t1,
      ...avatarProps
    } = t0);
    $[0] = t0;
    $[1] = avatarProps;
    $[2] = className;
    $[3] = fallbackText;
    $[4] = icon;
    $[5] = image;
    $[6] = t1;
  } else {
    avatarProps = $[1];
    className = $[2];
    fallbackText = $[3];
    icon = $[4];
    image = $[5];
    t1 = $[6];
  }
  const isCoreUnit = t1 === undefined ? false : t1;
  let t2;
  if ($[7] !== className) {
    t2 = cn("relative flex", className);
    $[7] = className;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("h-8.5 w-8.5 shrink-0");
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== image) {
    t4 = image ? <AvatarImage src={image} alt="" /> : null;
    $[10] = image;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== fallbackText) {
    t5 = <AvatarFallback>{fallbackText}</AvatarFallback>;
    $[12] = fallbackText;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== avatarProps || $[15] !== t4 || $[16] !== t5) {
    t6 = <Avatar data-slot="circle-avatar-with-icon-avatar" className={t3} {...avatarProps}>{t4}{t5}</Avatar>;
    $[14] = avatarProps;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== icon || $[19] !== isCoreUnit) {
    t7 = icon && <div data-slot="circle-avatar-with-icon-icon" className={cn("absolute top-2.5 left-2 z-20 flex h-11 w-11", isCoreUnit ? "text-status-progress" : "text-status-success")}><TwoUserIcon className="size-full" /></div>;
    $[18] = icon;
    $[19] = isCoreUnit;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t2 || $[22] !== t6 || $[23] !== t7) {
    t8 = <div data-slot="circle-avatar-with-icon-container" className={t2}>{t6}{t7}</div>;
    $[21] = t2;
    $[22] = t6;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
}
export { AvatarWithIcon };